// extracted by mini-css-extract-plugin
export var wrapper = "sharer-module--wrapper--xCaQ7";
export var list = "sharer-module--list--qWIgn";
export var message = "sharer-module--message--2BtHX";
export var messageShow = "sharer-module--messageShow--2R7+i";